import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'app-sign-in',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss',
})
export class SignInComponent implements OnInit {
    credentials = { email: '', password: '' };
    emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    isLoading = false;
    errorMessage = '';
    isCheckingAuth = true;
    showPassword: boolean = false;

    constructor(private authService: AuthService, private router: Router) {}

    ngOnInit(): void {
        const token = localStorage.getItem('a_id');
        const user = this.authService.getCurrentUser();

        // Jika token & user valid → langsung arahkan RoleGuard
        if (token && user) {
            this.router.navigate(['/dashboard'], { replaceUrl: true });
            return;
        }

        // Kalau tidak valid
        localStorage.removeItem('a_id');
        localStorage.removeItem('user');
        this.isCheckingAuth = false;
    }

    async onSignIn(): Promise<void> {
        this.errorMessage = '';

        if (
            !this.credentials.email.trim() ||
            !this.credentials.password.trim()
        ) {
            this.errorMessage = 'Please enter both email and password';
            return;
        }

        if (!this.emailRegex.test(this.credentials.email)) {
            this.errorMessage = 'Please enter a valid email address';
            return;
        }

        this.isLoading = true;

        try {
            const result = await this.authService.signIn(this.credentials);

            if (result.success) {
                this.isCheckingAuth = false;
                
                // Force change password takes priority
                if (result.mustChangePassword) {
                    if (result.needsOutletSelection) {
                        // Still need outlet selection first, then will redirect after
                        this.router.navigate(['/select-outlet'], { replaceUrl: true });
                    } else {
                        this.router.navigate(['/settings/change-password'], { replaceUrl: true });
                    }
                } else if (result.needsOutletSelection) {
                    this.router.navigate(['/select-outlet'], { replaceUrl: true });
                } else {
                    this.router.navigate(['/dashboard'], { replaceUrl: true });
                }
            } else {
                this.errorMessage = 'Invalid email or password';
            }
        } catch (error: any) {
            this.errorMessage =
                error.message || 'An error occurred during login.';
        } finally {
            this.isLoading = false;
        }
    }
}
